import React, { useEffect, useState } from 'react';
import '../../../styles/components/MyJobsList/MyBottomNavigation.scss';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Icon from "@material-ui/core/Icon";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import { FormatListBulleted } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from '@mui/icons-material/Home';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import RoutingService from '../../../services/RoutingService';
import CaptchaIcon from '../../../assets/captcha.svg';



function MyBottomNavigation(props) {
    const { userId,name }=props;

  const [value, setValue] = useState('Empty');
  return(
      <div className="sticky_bottomNavigationBar">
        <BottomNavigation
        
        sx={{ width: '100%', height:'70px' }}
          showLabels
          value={value}

          onChange={(event, newValue) => {
            console.log(newValue);
            setValue(newValue);
            if(newValue == "knowledgeCentre"){
              RoutingService.gotoMyKnowledgeCentre({
                search: `userId=${encodeURIComponent(userId)}`,
              });
            }
            else if(newValue == "status"){
              RoutingService.gotoMyJobStatus({
                search: `userId=${encodeURIComponent(userId)}`,
              });
            }
            else if(newValue == "solveAndEarn"){
              RoutingService.gotoCaptcha({
                search: `userId=${encodeURIComponent(userId)}`,
              });
            } 
            
          }}
        >

          <BottomNavigationAction style={{
              color:name == "status" ? "#D34714" : "",
              pointerEvents: 'none',

          }}
            label="Applied jobs" value="status" icon={<ShoppingBagIcon />}/>

          {/* <BottomNavigationAction style={{
              color:name == "prayerUI" ? "#D34714" : ""
          }}

            label="Solve & Earn" value="solveAndEarn" icon={<img src={CaptchaIcon} />}/> */}

          <BottomNavigationAction  style={{
              color:name == "knowledgeCentre" ? "#D34714" : "",
          }}
            label="Mitra Shots" value="knowledgeCentre" icon={<TipsAndUpdatesIcon />} />

        </BottomNavigation>
    </div>
  );
}

export default MyBottomNavigation;
